import * as React from "react";
export function SvgSchemaViewerCurrencyDiscrete(
  props: React.SVGProps<SVGSVGElement>
): JSX.Element {
  return (
    <svg width={24} height={17} {...props}>
      <path
        d="M12.3 7.4c-1.7-.6-2.3-.9-2.3-1.9 0-.9 1-1.5 2.3-1.5.9 0 1.5.3 2 .9l.7-.7c-.4-.6-1.1-1-2-1.2V1h-1v2c-1.8.1-3.1 1.2-3.1 2.6 0 1.7 1.1 2.2 2.9 2.9 1.6.6 2.1 1 2.1 1.9 0 1-.9 1.6-2 1.6-1 0-1.6-.1-2.3-1l-.6.8c.4.6 1 1 2 1.2v2h1v-1.9c1.9 0 3-1.1 3-2.7.1-1.7-.7-2.2-2.7-3z"
        fill="#367e9c"
      />
    </svg>
  );
}
